import { render, staticRenderFns } from "./ApexCommentBarChart.vue?vue&type=template&id=625dd8b2&scoped=true&"
import script from "./ApexCommentBarChart.vue?vue&type=script&lang=js&"
export * from "./ApexCommentBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexCommentBarChart.vue?vue&type=style&index=0&id=625dd8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625dd8b2",
  null
  
)

export default component.exports